/** Composition */
export type CompositionKeyword = 'oneOf' | 'anyOf' | 'allOf' | 'not'

export const compositions: CompositionKeyword[] = ['oneOf', 'anyOf', 'allOf', 'not']
